import { FileCard } from '../../../atoms/Card/FileCard'
import React, { useContext } from 'react'
import { TimelineEventAttachment as TimelineEventAttachmentType } from '../types/TimelineEventTypes'
import { TimelineProviderContext } from '../providers/TimelineProvider'

interface Props extends React.HTMLAttributes<HTMLLIElement> {
    attachment: TimelineEventAttachmentType
    children: React.ReactNode
}

export const TimelineEventAttachment = ({ attachment, children }: Props) => {
    const { downloadAttachmentHandler } = useContext(TimelineProviderContext)

    return (
        <li className="min-w-0">
            <FileCard file={attachment} downloadFile={downloadAttachmentHandler}>
                {children}
            </FileCard>
        </li>
    )
}
